/**
 * 获取手机验证码时的图片验证码
 */
import React from 'react';
import { Button, Icon, Toast, } from 'antd-mobile';
import api from './api';
import {post} from '../../utils/request';
import './index.less';

class VerificationCode extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      img:'',
    }
  }
  componentWillMount() {
      this.getPhotoValidCode();
  }

  getPhotoValidCode(){
      post({
          url: api.getPhotoValidCode, 
          data: {
              phoneNumber: this.props.phoneNumber,
              businessType: 'LOG_IN'
          }
      }).then((res) => {
          // console.log('图片验证码', res);
          if(res.result === 'success'){
              this.setState({
                  // TPYZMtype: true,
                  img: 'data:image/jpeg;base64,'+res.data
              });
          }else{
              Toast.info('图片验证码获取失败',1);
          }
      }, (res)=>{
          Toast.info('图片验证码获取失败',1);
      });
  }

  render() {

    const { img} = this.state;
    return (
      <div className="VerificationCode">
        <div>
            <h2>请输入图形验证码</h2>
            <div className="inputBox">
                <input id="TPyanzhengma" type="text" placeholder="请输入" />
                <div className="imgCodeBox" onClick={()=>{
                    this.getPhotoValidCode();
                }}><img src={img} /></div>
            </div>
            <Button inline onClick={()=>{
                this.props.onCancel('');
            }}>取消</Button>
            <Button inline type="primary" onClick={()=>{
                var value = document.getElementById('TPyanzhengma').value;
                if(!value){
                    Toast.info('请填写图片验证码',1);
                    return
                }
                this.props.onCancel(value);
                // this.setState({
                //     TPYZMtype: false,
                //     TPyanzhengma: value
                // },()=>{
                //     this.timerFN();
                // });
            }}>确定</Button>
        </div>
    </div>
    );
  }
}

export default VerificationCode;


// WEBPACK FOOTER //
// ./src/components/VerificationCode/index.js